// IMPORTANT: These breakpoints should always align with the breakpoints
// in /styles/front/navigation/header/_config.scss
const breakpoints = {
  style: 1024,
  small: 1240,
  large: 1350,
  xl: 1520,
};

export default {
  mainMobilePanelId: 'Main',
  mobileNavTrigger: '[data-mobile-menu-trigger]',
  mobileNavActiveClass: 'page-header--active',
  mobileContainer: '.page-header__mobile-container',
  mobileMainPanel: '[data-mobile-panel-content="Main"]',
  mobileHeader: '.page-header__mobile-top',
  subNavListItem: '.page-header__link--has-subnav',
  mobilePanelTrigger: '[data-mobile-panel-trigger]',
  mobilePanelContent: '[data-mobile-panel-content]',
  pageOverlay: '.page-header__overlay',
  activeClass: 'active',
  hideClass: 'hide',
  bottomCssVarName: '--sticky-page-nav-bottom',
  breakpoints,
};
